module.exports = __webpack_public_path__ + "assets/img/11s.37e3e177.png";